export default __webpack_public_path__ + "static/media/leaderboard.bf4bdac0.svg";